import { compact } from 'lodash';

import { Color } from '@dreryk/color-common-api';

import { ColorSegment } from '@dreryk/react-components';

import { StyledReceptionServiceColorBar } from './ReceptionServiceColorBar.styled';

type ReceptionService = {
   color?: Color;
};

type ReceptionServiceColorBarProps = {
   readonly receptionServices: ReceptionService[];
   readonly appointmentCancelled: boolean;
};

export const ReceptionServiceColorBar = (props: ReceptionServiceColorBarProps): JSX.Element => {
   const [firstService, secondService, thirdService] = props.receptionServices;

   const segments: ColorSegment[] = compact([
      firstService && {
         color: firstService.color?.asHexString(),
         percentage: secondService ? '60%' : '100%',
      },
      secondService && {
         color: secondService.color?.asHexString(),
         percentage: thirdService ? '20%' : '40%',
      },
      thirdService && {
         color: thirdService.color?.asHexString(),
         percentage: '20%',
      },
   ]);

   return (
      <StyledReceptionServiceColorBar
         testId={'receptionServiceColorBar'}
         segments={segments}
         appointmentCancelled={props.appointmentCancelled}
      />
   );
};
